import { Component, OnInit, AfterViewInit, ElementRef } from '@angular/core';
import { CookieService } from '../../cookie.service';
import { RestApiService } from '../../rest-api.service';
import { StaticFileService } from '../../static-file.service';
import { GoogleAnalyticsService } from '../../google-analytics.service';

@Component({
  selector: 'app-cart-inventory',
  templateUrl: './cart-inventory.component.html',
  styleUrls: ['../cart-page.component.css']
})
export class CartInventoryComponent implements OnInit, AfterViewInit {
  public cartItems: any[] = [];
  public subtotalText: string;
  private subtotal: number;

  constructor(private cookieService: CookieService,
              private restApi: RestApiService,
              public staticFilesService: StaticFileService,
              private gs: GoogleAnalyticsService,
              private el: ElementRef) { }

  ngOnInit() {
    this.init();
  }

  ngAfterViewInit() {
    this.scrollToMe();
  }

  private init() {
    this.subtotal = 0;
    this.subtotalText = '$0.00';
    const items = this.cookieService.getCartItems();
    for (let item of items) {
      this.populateSKUData(item);
    }
  }

  private async populateSKUData(sku: string): Promise<any> {
    try {
      let item = await this.restApi.getSKUCartInfo(sku);
      item['quantity'] = this.cookieService.getItemQuantity(sku);
      item['cost'] = this.setItemCost(item);
      this.cartItems.push(item);
      this.updateSubtotal();
    } catch(err) {
      alert("Oh no! An item you wanted is no longer available. It's been removed from your cart.");
      this.cookieService.removeItemFromCart(sku);
    }
  }

  private setItemCost(item): string {
    const total = item.price * item.quantity;
    return this.parseCostToReadable(total);
  }

  private removeItem(id: string) {
    const index = this.cartItems.findIndex((i) => i.id == id);
    const item = this.cartItems.find((i) => i.id == id);
    this.cartItems.splice(index, 1);
    this.updateSubtotal();
    this.cookieService.removeItemFromCart(id);
    this.gs.event('remove_from_cart', 'ecommerce', 'click', id);
  }

  public updateQuantity(evt, item) {
    let newQuantity = parseInt(evt.target.value, 10);
    if (newQuantity <= 0) {
      newQuantity = 1;
      evt.target.value = newQuantity;
    } else if (item.max_quantity > 0 && newQuantity > item.max_quantity) {
      newQuantity = item.max_quantity;
      evt.target.value = newQuantity;
    }
    this.cookieService.updateItemQuantity(item.id, newQuantity);
    item['quantity'] = newQuantity;
    item['cost'] = this.setItemCost(item);
    this.updateSubtotal();
  }

  private updateSubtotal() {
    this.subtotal = 0;
    for (let i of this.cartItems) {
      this.subtotal += i.price * i.quantity;
    }
    if( this.subtotal === 0) {
      this.subtotalText = '$0.00';
    } else {
      this.subtotalText = this.parseCostToReadable(this.subtotal);
    }
  }

  private parseCostToReadable(cost: number): string {
    const num = cost.toString();
    const cents = num.substring(num.length - 2);
    const dollars = num.substring(0, num.length - 2);
    return `$${dollars}.${cents}`;
  }

  private scrollToMe() {
    this.el.nativeElement.scrollIntoView({behavior:'smooth'});
  }

}
